import useExperience from 'canvas_states/experience/useExperience';
import { findExperienceCurrencyCode } from 'canvas_states/currency/useCurrentCurrency';
import LanguageCurrencySettings from '../../../molecules/LanguageCurrencySettings';
import type Language from '../../../../../types/Language';
import useShouldHideSelector from '../hooks/useShouldHideSelector';
import useLanguageCurrencySelectorsProps from '../hooks/useLanguageCurrencySelectorsProps';

export interface HeaderLanguageCurrencyButtonProps {
  hideCurrencySelector?: boolean;
  onLanguageChange?: (newLanguage: Language) => void;
  pid: string;
}

const HeaderLanguageCurrencyButton: React.FC<HeaderLanguageCurrencyButtonProps> = ({
  hideCurrencySelector = false,
  onLanguageChange,
  pid,
}) => {
  const { loading, experience } = useExperience().states;

  const { shouldHideCurrencySelector, shouldHideLanguageSelector } = useShouldHideSelector(hideCurrencySelector).states;
  const shouldHideLanguageCurrencySettings = shouldHideCurrencySelector && shouldHideLanguageSelector;

  const {
    actions: { handleCurrencyChange, handleLanguageChange },
    states: { currentCurrency, currentLanguage, languages, currencies },
  } = useLanguageCurrencySelectorsProps(pid, onLanguageChange);

  //  display the language or currency selector only on the offers page, and only if at least one of the selectors is available
  if (shouldHideLanguageCurrencySettings) return <></>;

  return (
    <LanguageCurrencySettings
      languages={languages}
      currencies={currencies}
      currentLanguage={currentLanguage}
      currentCurrency={currentCurrency}
      hideCurrencySelector={shouldHideCurrencySelector}
      disableCurrencySelector={loading || Boolean(findExperienceCurrencyCode(experience))}
      hideLanguagesSelector={shouldHideLanguageSelector}
      handleLanguageChange={handleLanguageChange}
      handleCurrencyChange={handleCurrencyChange}
    />
  );
};

export default HeaderLanguageCurrencyButton;
